import { logEvent } from 'firebase/analytics';
import { analytics } from './config';

export const trackPageView = (pagePath) => {
  if (!analytics) return;
  logEvent(analytics, 'page_view', {
    page_path: pagePath,
    page_title: document.title
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!analytics) return;
  logEvent(analytics, eventName, params);
};
